import { render, staticRenderFns } from "./uwbPage.vue?vue&type=template&id=244a3656&scoped=true&"
import script from "./uwbPage.vue?vue&type=script&lang=js&"
export * from "./uwbPage.vue?vue&type=script&lang=js&"
import style0 from "./uwbPage.vue?vue&type=style&index=0&id=244a3656&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244a3656",
  null
  
)

export default component.exports